import React from 'react';
import { ShoppingBag, X } from 'lucide-react';

const OrderAlert = ({ alert, onClose, onView, t, tenantData }) => {
    if (!alert) return null;

    const getTableDisplayName = (tableId) => {
        if (!tableId || tableId === 'Manuel') return 'Manuel Sipariş';
        if (tableId === 'Paket') return 'Paket Servis / Gel-Al';
        const table = tenantData?.tables?.find(t => String(t.id) === String(tableId));
        if (table) return table.name;
        return String(tableId).startsWith('Masa') ? tableId : `${t('portal.table', 'Masa')} ${tableId}`;
    };

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'var(--primary)',
            color: 'white',
            padding: '16px 24px',
            borderRadius: '16px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            animation: 'slideInDown 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
        }}>
            <ShoppingBag size={24} />
            <div>
                <div style={{ fontWeight: 800 }}>{t('newOrderAlert', 'Yeni Sipariş!')}</div>
                <div style={{ fontSize: '0.8125rem', opacity: 0.9 }}>
                    {getTableDisplayName(alert.tableNumber)} için yeni bir sipariş geldi.
                </div>
            </div>
            <button
                onClick={onView}
                style={{
                    background: 'white',
                    color: 'var(--primary)',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: '8px',
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    cursor: 'pointer'
                }}
            >
                Görüntüle
            </button>
            <button
                onClick={onClose}
                style={{ background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', padding: '4px' }}
            >
                <X size={18} />
            </button>
            <style>{`
                @keyframes slideInDown {
                    from { transform: translate(-50%, -100%); opacity: 0; }
                    to { transform: translate(-50%, 0); opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default OrderAlert;
